import { ButtonV2 } from '@findy-code/yuffie/ui/button/v2';
import { useMemo, useState } from 'react';

export const useExpandableItems = <T,>(
  items: T[],
  limit: number,
  buttonLabel: string
) => {
  const [isVisibleAllItems, setIsVisibleAllItems] = useState(false);

  const displayItems = useMemo(() => {
    if (!isVisibleAllItems) {
      return items.slice(0, limit);
    }
    return [...items];
  }, [isVisibleAllItems, items, limit]);

  const ExpandButton = () =>
    items.length > limit && !isVisibleAllItems ? (
      <div
        style={{
          display: 'grid',
          placeItems: 'center',
          marginTop: 'var(--fds-spacing-500)',
        }}
      >
        <ButtonV2
          size="s"
          subVariant="positive"
          variant="secondary"
          onClick={() => setIsVisibleAllItems(true)}
        >
          {buttonLabel}
        </ButtonV2>
      </div>
    ) : null;

  return {
    displayItems,
    ExpandButton,
    isVisibleAllItems,
  };
};
